import { V2ComponentBase } from 'util/fetchComponentsV2'

/**
 * Walk supplier preferences from highest to lowest and return the first SKU in
 * `candidateCodes` that the supplier has marked `is_in_stock`. Within a single
 * supplier, the order of `candidateCodes` breaks ties.
 */
export function pickSupplierDefaultByPreference<T extends V2ComponentBase>(
  components: T[],
  orderedSuppliers: string[],
  candidateCodes: readonly string[]
): string | null {
  if (!orderedSuppliers.length || !components.length) return null
  const byCode = new Map(components.map((component) => [component.code, component]))
  for (const supplier of orderedSuppliers) {
    for (const code of candidateCodes) {
      const row = byCode.get(code)
      if (row?.ordering_v2?.some((ordering) => ordering.distributor === supplier && ordering.is_in_stock)) {
        return code
      }
    }
  }
  return null
}
